(function ($) {
$(document).ready(function () {
    $('.slider-video').each(function () {
        var $section = $(this);
            var slideCount = $section.find('.slider-single').children().length;
            if (slideCount > 1) {
                $section.find('.slider-overlay').slick({
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    asNavFor: $section.find('.slider-single'),
                    cssEase: "linear",
                    dots: false,
                    draggable: false,
                });

                $section.find('.slider-single').slick({
                    centerMode: true,
                    centerPadding: "0",
                    slidesToShow: 1,
                    arrows: true,
                    draggable: false,
                    asNavFor: $section.find('.slider-overlay'),
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                draggable: false,
                                swipe: false,
                                touchMove: false,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: true,
                                // centerMode: false,
                                slidesToShow: 1,
                                draggable: false,
                                swipe: false,
                                touchMove: false,
                            },
                        },
                        {
                            breakpoint: 595,
                            settings: {
                                arrows: true,
                                // centerMode: false,
                                slidesToShow: 1,
                                draggable: false,
                                swipe: false,
                                touchMove: false,
                            },
                        },
                    ],
                });
            }

            $section.find('.slider-single .img-wrap').on('click', function () {
                $section.find('.column-wrapper').addClass('active');
            });

            $section.find('.container').css({ 'opacity': '1', 'visibility': 'visible' });
    });

    // Global close/escape logic
    $(document).on('click keydown', function (e) {
        var target = e.target;
        if ($(target).hasClass('column-wrapper') || $(target).hasClass('close')) {
            $('.column-wrapper').removeClass('active');
        } else if (e.key === 'Escape') {
            $('.column-wrapper').removeClass('active');
        }
    });

    $(document).on('click keydown', function (e) {
        var target = e.target;
        if ($(target).hasClass('video') || $(target).hasClass('close')) {
            $('.video').removeClass('active');
            $('.slider-video .video iframe').attr('src', "");
        } else if (e.key === 'Escape') {
            $('.video').removeClass('active');
        }
    });
});

    $(window).on("load resize orientationchange", function () {
      $(".subNav-menu").css({ opacity: 1 });
    });

    $(window).on("load", function () {
      $(".slider-video").each(function () {
        var $this = $(this);
        $this
          .find(".slider-overlay")
          .wrap('<div class="column-wrapper"></div>')
          .css({ opacity: 1 });
      });
    });



    jQuery('iframe[src*="https://www.youtube.com/embed/"]').addClass("youtube-iframe");

    jQuery(".slick-arrow").click(function () {
        // changes the iframe src to prevent playback or stop the video playback in our case
        $('.youtube-iframe').each(function (index) {
            $(this).attr('src', $(this).attr('src'));
            return false;
        });

    });

    $slick_slider = $('.slider-video');
    $slick_slider.on('afterChange', function (event, slick, currentSlide) {
        if ($('.slider-overlay.slider-wrapper').hasClass('slick-current')) {
            $(".video-play").click(function (e) {
                e.preventDefault();
                var videoSrc = $(this).attr('href'), video_id, ampersandPosition;
                if (videoSrc.indexOf("watch") > 0) {
                    video_id = videoSrc.split("v=")[1];
                    ampersandPosition = video_id.indexOf("&");
                    if (ampersandPosition != -1) {
                        video_id = video_id.substring(0, ampersandPosition);
                    }
                    videoSrc = "https://youtube.com/embed/" + video_id;
                } else if (videoSrc.indexOf("youtu.be") > 0) {
                    video_id = videoSrc.split("e/")[1];
                    ampersandPosition = video_id.indexOf("&");
                    if (ampersandPosition != -1) {
                        video_id = video_id.substring(0, ampersandPosition);
                    }
                    videoSrc = "https://youtube.com/embed/" + video_id;
                }
                $('.slider-video .video iframe').attr('src', videoSrc);
                $('.slider-video .video iframe').addClass('youtube-video');
                $('.slider-video .video').addClass('active');

            });
        } else {
            var videoSrc = $('iframe', this).attr('src', '');
        }
        $('.slider-video .column-wrapper.active .slick-arrow').click(function () {
            var videoSlide = $(".slider-video .slick-current.slick-active").find(".video")
            if (videoSlide) {
                videoSlide.removeClass("active")
            }

        });
    });
    var videoSrc, video_id, ampersandPosition
    $(".video-play").click(function (e) {
        e.preventDefault();
        videoSrc = $(this).attr('href')
        console.log(videoSrc.split("?"))
        if (videoSrc.indexOf("watch") > 0) {
            video_id = videoSrc.split("v=")[1];
            ampersandPosition = video_id.indexOf("&");
            if (ampersandPosition != -1) {
                video_id = video_id.substring(0, ampersandPosition);
            }
            videoSrc = "https://youtube.com/embed/" + video_id;
        } else if (videoSrc.indexOf("youtu.be") > 0) {
            video_id = videoSrc.split("e/")[1];
            ampersandPosition = video_id.indexOf("&");
            if (ampersandPosition != -1) {
                video_id = video_id.substring(0, ampersandPosition);
            }
            videoSrc = "https://youtube.com/embed/" + video_id;
        }

        $('.slider-video .video iframe').attr('src', videoSrc);
        $('.slider-video .video iframe').addClass('youtube-video');
        $('.slider-video .video').addClass('active');
        $('.slider-video .video .play-btn').parent().addClass('active');

    });

})(jQuery);